/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_TitleInputs */

const en_fc_home_paths_title = /** @type {(inputs: Fc_Home_Paths_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your next step`)
};

/**
* | output |
* | --- |
* | "Choose your next step" |
*
* @param {Fc_Home_Paths_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_title = /** @type {((inputs?: Fc_Home_Paths_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_title(inputs)
});
export { fc_home_paths_title as "fc.home.paths.title" }